import { Component, OnInit } from '@angular/core';
import { AbstractBlDynamicGuide, GuideContent, ModalReason, BlDialogService } from '@blcloud/bl-ng-ui-component';
import {
  StringUtils
} from '@blcloud/bl-common';
import {
  forEach as _forEach,
  some as _some,
  isNil as _isNil
} from 'lodash';
import { IProfileEntryCustomerVehicleLinkOptDtl } from '@blcloud/bl-datamodel';

/**
 * 車両追加顧客選択
 */
@Component({
  templateUrl: './customer-select-guide.component.html',
  styleUrls: ['./customer-select-guide.component.scss'],
})
export class CustomerSelectGuideComponent extends AbstractBlDynamicGuide implements OnInit {

  data: { profileEntryCustomerVehicleLinkOptDtlList?: IProfileEntryCustomerVehicleLinkOptDtl[] };

  /** ガイドコンテンツ */
  guideContents: GuideContent[] = [
    {
      navText: '車両を追加する顧客を選択してください',
      tableContent: {
        headers: [
          { key: 'customerName', label: '顧客名', width: '100%', align: 'left' },
        ]
      }
    },
  ];

  constructor(
    private dialogService: BlDialogService,
  ) {
    super();
  }

  ngOnInit() {
    this.showLoading();
  }

  /**
   * モーダルウィンドウ表示後イベントハンドラ
   *
   * モーダルウィンドウが表示後に初期データが設定された後にコールされます。
   */
  onShown() {
    this.setData();
  }

  /**
   * データを入手する
   */
  private setData() {
    this.showLoading();
    const setList = [];
    setList.push({
      customerName: '新規顧客',
      customerCode: 0,
    });
    _forEach(this.data.profileEntryCustomerVehicleLinkOptDtlList, data => {
      const checkCustomer = _some(setList, checkData => checkData.customerCode === data.customerCode);
      if (!checkCustomer && !_isNil(data.customerCode)) {
        setList.push({
          customerName: StringUtils.concat(data.customerFamilyName, '　', data.customerGivenName),
          customerCode: data.customerCode,
        });
      }
    });
    this.setTableDatas(setList);
    this.hideLoading();
  }

  /**
   * モーダル終了イベント
   * @param reason　モーダル終了理由
   */
  dismiss(reason: ModalReason) {
    if (reason === ModalReason.Done) {
      this.dialogService.confirm('選択した顧客に車両を追加します。<br>よろしいですか？').subscribe(
        modalRef => {
          modalRef.hide();
          if (modalRef.reason === ModalReason.Done) {
            this.emitDismissEvent(reason);
          }
        }
      );
    } else {
      this.emitDismissEvent(reason);
    }
  }
}




// WEBPACK FOOTER //
// ./src/app/page/profile-entries-page/customer-select-guide/customer-select-guide.component.ts